import React from 'react'
import LongMenu from './LongMenu'
import Navbar from './Navbar'


export default function Header() {

  return (
    <header>
      <Navbar />
      <LongMenu />
    </header>
  )
}
